import '~/js/modules/stickyNav';

// Variable Declaration
const resortsList = document.getElementById('resorts-list');
const resortsViews = document.getElementById('resorts-views');

// Internals Variables
const internals = {
  view: null
};

// Click handlers
const clickMore = (e) => {
  const node = e.target;

  if (node.classList.contains('learn-more')) {
    e.preventDefault();

    const id = node.getAttribute('href').slice(1);

    internals.view = document.getElementById(id);

    resortsList.style.display = 'none';
    resortsViews.style.display = 'block';
    internals.view.style.display = 'block';

    window.scrollTo(0, internals.view.offsetTop - 160);
  }
};

const clickBack = (e) => {
  const node = e.target;

  if (node.classList.contains('back-btn')) {
    resortsList.style.display = '';
    resortsViews.style.display = '';
    internals.view.style.display = '';
  }
};

const handleClick = function handler(e) {
  e.preventDefault();

  const $this = $(this);
  const $main = $('html, body');
  const $elScrollTo = $('.' + $this.data('scroll-to'));
  const top = $elScrollTo.offset().top;

  $main.animate({
    scrollTop: top - 85
  }, 600);
};

$('.js-scroll-below').on('click', handleClick);

// Event listeners
resortsList.addEventListener('click', clickMore);
resortsViews.addEventListener('click', clickBack);
